import React from 'react';
import Hero from './Hero';
import Content from './Content';
import DoctorReview from './DoctorReview';
import WhatWeOffer from './WhatWeOffer';

const Home = () => {
    return (
        <>
            <Hero />
            <WhatWeOffer />
            <Content />
            <DoctorReview />
        </>
    );
};

export default Home;